import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutPage.css';

const AboutPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="about-page">
      <div className="about-container">

        {/* 헤더 섹션 */}
        <div className="about-header">
          <h1 className="main-title">{t('about.title')}</h1>
          <p className="description">
            {t('about.description')}
          </p>
        </div>

        {/* 콘텐츠 섹션 */}
        <div className="about-content">
          <div className="content-grid">
            <div className="content-section">
              <h3><span className="check-icon">✓</span> {t('about.evaluationStructure')}</h3>
              <p>
                {t('about.evaluationDescription')}
              </p>
            </div>

            <div className="content-section">
              <h3><span className="check-icon">✓</span> {t('about.keyFeatures')}</h3>
              <ul>
                <li>{t('about.feature1')}</li>
                <li>{t('about.feature2')}</li>
                <li>{t('about.feature3')}</li>
                <li>{t('about.feature4')}</li>
              </ul>
            </div>
          </div>

          <div className="content-section single">
            <h3><span className="check-icon">✓</span> {t('about.targetUsers')}</h3>
            <ul>
              <li><strong>{t('about.targetStudent')}</strong> {t('about.targetStudentDesc')}</li>
              <li><strong>{t('about.targetTeacher')}</strong> {t('about.targetTeacherDesc')}</li>
              <li><strong>{t('about.targetParent')}</strong> {t('about.targetParentDesc')}</li>
              <li><strong>{t('about.targetInstitution')}</strong> {t('about.targetInstitutionDesc')}</li>
              <li><strong>{t('about.targetGeneral')}</strong> {t('about.targetGeneralDesc')}</li>
            </ul>
          </div>
        </div>

        {/* 하단 CTA 섹션 */}
        <div className="about-cta">
          <div className="cta-content">
            <p className="cta-text">
              {t('about.ctaText1')}<br/>
              {t('about.ctaText2')}<br/>
              {t('about.ctaText3')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 